import styled from '@emotion/styled'

const FormRecaptcha = styled.div`
  display: flex;
  justify-content: center;
`

export default FormRecaptcha
